var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHalfSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 355,
    height: 355,
    viewBox: "0 0 355 355",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke: #707070;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #f8bd34;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    className: "cls-1",
    width: 355,
    height: 355,
    transform: "translate(0 979)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_24",
    "data-name": "Mask Group 24",
    className: "cls-2",
    transform: "translate(0 -979)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-76.402 900.094)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PRINT_6",
    "data-name": "PRINT 6",
    transform: "translate(-0.005 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    className: "cls-3",
    d: "M251.389,32.79l44.618,218.592L77.415,296,32.8,77.408,251.389,32.79M254.905,0a28.177,28.177,0,0,0-5.457.548L21.928,47.016A27.4,27.4,0,0,0,.555,79.349l46.468,227.52A27.4,27.4,0,0,0,73.9,328.813a28.177,28.177,0,0,0,5.457-.548L306.876,281.8a27.4,27.4,0,0,0,21.373-32.333L281.781,21.921A27.4,27.4,0,0,0,254.905,0Z",
    transform: "translate(0.005 0)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfSquare);
export default __webpack_public_path__ + "static/media/half_square.742390875bccf2ad85a9a581d0be70f6.svg";
export { ForwardRef as ReactComponent };